import React from 'react';
import PropTypes from 'prop-types';
import { NAV_ICONS } from './navIcons';

/**
 * One icon in the sidebar.
 *
 * Takes a key from navIcons.js rather than an imported file, so a menu entry
 * names the *idea* it points at ("company", "earnings") and the artwork for
 * that idea is decided in one place. The colour is not passed in either: the
 * icon inherits its row's text colour through the `.nav-icon` rule in
 * custom.css, so hover, active and dark mode need nothing here.
 *
 * An unknown key falls back to a dot instead of disappearing. A sub-menu is a
 * column of labels at a fixed indent, and one row silently losing its icon
 * would pull its label out of line with the rest — a missing icon should look
 * like an oversight to fix, not like a layout bug.
 */
const NavIcon = ({ name, className = '' }) => {
  const Glyph = NAV_ICONS[name];

  if (!Glyph) {
    return (
      <span className={`nav-icon items-center justify-center ${className}`} aria-hidden="true">
        <span className="h-1.5 w-1.5 rounded-full bg-current opacity-40" />
      </span>
    );
  }

  return (
    <span className={`nav-icon ${className}`} aria-hidden="true">
      <Glyph />
    </span>
  );
};

NavIcon.propTypes = {
  /** A key from NAV_ICONS — the kind of destination, not the page. */
  name: PropTypes.string,
  /** Sizing and spacing; the icon has no size of its own. */
  className: PropTypes.string
};

export default NavIcon;
